import { render, staticRenderFns } from "./SendRequestHistoriesTable.vue?vue&type=template&id=8b645f32&scoped=true&lang=pug"
import script from "./SendRequestHistoriesTable.vue?vue&type=script&lang=ts"
export * from "./SendRequestHistoriesTable.vue?vue&type=script&lang=ts"
import style0 from "./SendRequestHistoriesTable.vue?vue&type=style&index=0&id=8b645f32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b645f32",
  null
  
)

export default component.exports